import { AsYouType } from 'libphonenumber-js'

const E164_MAX_DIGITS = 15

/**
 * Normalize raw phone input to +E.164 digits (no formatting).
 * Leading 8… (without +) is treated as Russia (+7…), same as existing paste handlers.
 */
export function normalizePhoneDigits(raw) {
  let text = String(raw ?? '').trim()
  if (!text) {
    return ''
  }

  const digitsOnly = text.replace(/\D/g, '')
  if (!digitsOnly) {
    return text.includes('+') ? '+' : ''
  }

  if (!text.includes('+') && digitsOnly.startsWith('8')) {
    return `+7${digitsOnly.slice(1, E164_MAX_DIGITS)}`
  }

  return `+${digitsOnly.slice(0, E164_MAX_DIGITS)}`
}

/**
 * Format phone as-you-type via libphonenumber.
 * Stops accepting digits once the number isValid() — prevents mask collapse on overflow.
 */
export function formatPhoneInput(raw) {
  const normalized = normalizePhoneDigits(raw)
  if (!normalized || normalized === '+') {
    return normalized
  }

  const digits = normalized.slice(1)
  let accepted = ''
  let formatted = '+'

  for (const digit of digits) {
    if (accepted) {
      const previous = new AsYouType()
      previous.input(`+${accepted}`)
      if (previous.getNumber()?.isValid()) {
        break
      }
    }

    const candidate = `${accepted}${digit}`
    const formatter = new AsYouType()
    formatted = formatter.input(`+${candidate}`)
    accepted = candidate
  }

  return formatted
}
